import { api } from './client'

/**
 * F-058 (TASK-0312): consumer for `GET /api/contracts/{id}/timeline`
 * (`ContractTimelineController.Get`). Read-only; no amounts anywhere in the response.
 */
export interface TimelineItem {
  /** UTC instant (ISO 8601). */
  occurredAt: string
  /** Stable machine kind, e.g. `stato_iniziale`, `stato_cambiato`, `nota`, `documento_scaricato`. */
  kind: string
  /** Italian title, ready to render. */
  title: string
  actorUserId: number | null
  actorName: string | null
  refType: string | null
  refId: number | null
  /** True only for the "state at load from the previous system" snapshot (not a real transition). */
  isSnapshot: boolean
}

export interface ContractTimeline {
  contractId: number
  items: TimelineItem[]
  /** True when more than 500 entries exist and the oldest were cut. */
  truncated: boolean
}

export const timelineApi = {
  forContract: (contractId: number) =>
    api<ContractTimeline>(`/api/contracts/${contractId}/timeline`),
}
